import React, { useId } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const InstructionAssistantModalShell = ({
  isOpen,
  title,
  ariaLabel,
  iconClassName,
  onClose,
  children,
  footer,
  keepMounted = false,
  compact = false,
}) => {
  const titleId = useId();
  const SOFT_CREAM_SURFACE = '#fbfaf7';
  const dialogStyle = compact
    ? {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 440,
        width: 'calc(100% - 24px)',
      }
    : {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 520,
      };
  const headerStyle = {
    borderBottom: '1px solid #edf0f2',
    flexShrink: 0,
    padding: compact ? '13px 16px 11px' : '16px 22px 12px',
  };
  // Body is the only scrolling region — header/footer stay pinned so the
  // footer's action buttons are always visible (see the flex-column card below).
  const bodyStyle = {
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
    padding: compact ? '10px 16px 14px' : '12px 22px 16px',
  };
  const footerStyle = {
    borderTop: 'none',
    flexShrink: 0,
    padding: compact ? '0 16px 16px' : '0 22px 18px',
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      labelledBy={titleId}
      unmountOnClose={!keepMounted}
      zIndex={100001}
      role="dialog"
      style={dialogStyle}
      contentClassName="border-0 bg-transparent shadow-none"
    >
      <div
        className="bg-white shadow-lg overflow-hidden d-flex flex-column"
        style={{ borderRadius: 18, maxHeight: 'calc(100vh - 3.5rem)' }}
      >
      <ModalHeader
        id={titleId}
        tag="div"
        style={headerStyle}
        close={
          <Button
            type="button"
            color="link"
            className="p-0 ml-auto d-inline-flex align-items-center justify-content-center text-muted"
            style={{
              backgroundColor: SOFT_CREAM_SURFACE,
              borderRadius: 10,
              fontSize: 22,
              height: 32,
              lineHeight: 1,
              width: 32,
            }}
            onClick={onClose}
            aria-label="Close"
          >
            <i className="fa fa-times" />
          </Button>
        }
      >
        <div
          className="d-flex align-items-center font-weight-bold text-dark"
          style={{
            fontSize: compact ? 16 : 18,
            lineHeight: 1.25,
            whiteSpace: 'nowrap',
          }}
        >
          {iconClassName && (
            <i
              className={`${iconClassName} mr-2`}
              style={{ color: '#1d9e75', fontSize: compact ? 17 : 19 }}
              aria-hidden="true"
            />
          )}
          {title || ariaLabel}
        </div>
      </ModalHeader>
      <ModalBody style={bodyStyle}>{children}</ModalBody>
      {footer && <ModalFooter style={footerStyle}>{footer}</ModalFooter>}
      </div>
    </Modal>
  );
};

export default InstructionAssistantModalShell;
